import { Pipe, PipeTransform } from '@angular/core'
import moment from 'moment-timezone'

@Pipe({
  name: 'dateTimeWithTimeZone',
  standalone: false
})
export class DateTimeWithTimeZone implements PipeTransform {
  transform(value: any, ...args: any[]) {
    if (!value) {
      return ''
    } else {
      const timezone = args[0] ? args[0] : ''
      return moment.tz(value, timezone).format('MM/DD/YYYY HH:mm z')
    }
  }
}
